import { locatorServiceAPI } from 'shared/services';

import {
  Country,
  CountriesRegionsFilter,
  CountriesRegions,
  AvoidedCountries
} from '../types';

export const countriesAPI = {
  getCountries: () => locatorServiceAPI.get<Country[]>('countries'),
  getCountriesRegions: (filter: CountriesRegionsFilter) => locatorServiceAPI.post<CountriesRegions>('countries/regions', filter),
  getAvoidedCountries: () => locatorServiceAPI.get<AvoidedCountries>('routes/excludable-countries')
};
